import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Currency from './Currency'
import { connect } from 'react-redux'

const CashBack = ({ price, hideIcon, hasCashBack, currency, ruleCashBack, showInstallments, isOnlyCash }) => {
  const convertedValue = ruleCashBack === '1' ? Math.floor(0.05 * price) : Math.round(price)

  return (
    <Fragment>
      {hasCashBack && isOnlyCash && (
        <div className='card-price-cashback col-auto txt-body-sm txt-font-body txt-left txt-bold color-success py-half'>
          <div className='row'>
            { !hideIcon && <div className='col-auto px-0 d-none d-lg-block'>
              <i className='icon_cashback icon-sm icon icon_reload color-success' />
            </div> }
            <div className='col-auto txt-body-sm' aria-label={`Ganhe ${convertedValue} ${currency.name || 'pontos'} de volta`}>
              {showInstallments
                ? (<Fragment>E você recebe <Currency value={convertedValue} {...currency} /> de volta</Fragment>)
                : (<Fragment>Ganhe <Currency value={convertedValue} {...currency} /></Fragment>)}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

CashBack.propTypes = {
  price: PropTypes.number,
  hideIcon: PropTypes.bool,
  hasCashBack: PropTypes.bool,
  ruleCashBack: PropTypes.string,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  showInstallments: PropTypes.bool,
  isOnlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash: isOnlyCash }) => {
  return ({
    isOnlyCash
  })
}

export default connect(mapStateToProps)(CashBack)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/CashBack.js